import React, { memo } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { HighlightedMarkup } from '../HighlightedMarkup'

const useOptionMarkupStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
  },
}))

interface IOptionMarkupProps {
  text: string
  inputValue: string
}

export const OptionMarkup = memo<IOptionMarkupProps>(({ inputValue, text }) => {
  const classes = useOptionMarkupStyles()
  return (
    <div className={classes.root}>
      <HighlightedMarkup suggestion={text} value={inputValue} />
    </div>
  )
})
